<div class="dynamic-policies">
  <select
    class="policy-group-select"
    (change)="onGroupChange($event.target.value)">
    <option value="">Select policy group</option>
    <option *ngFor="let g of policyGroups" [value]="g.id">
      {{ g.name | lowercase }}
    </option>
  </select>

  <div *ngFor="let section of sections" class="policy-section">
    <ng-container *ngIf="sectionHasAnswerableQuestions(section)">
      <h4>{{ section.title | lowercase }}</h4>

      <p *ngIf="section.description">
        {{ section.description | lowercase }}
      </p>
    </ng-container>

    <ng-container *ngFor="let q of section.questions">
    <div *ngIf="hasAnswers(q)" class="policy-question">
      <label>{{ q.title | lowercase }}</label>

      <div *ngIf="q.questionTypeId === QuestionType.YesNo"
           class="option-group radio">
        <label class="option">
          <input type="radio"
                 [name]="'q' + q.id"
                 value="Yes"
                 [(ngModel)]="q.currentValue"
                 (change)="onAnswerChanged(q)">
          <span>yes</span>
        </label>

        <label class="option">
          <input type="radio"
                 [name]="'q' + q.id"
                 value="No"
                 [(ngModel)]="q.currentValue"
                 (change)="onAnswerChanged(q)">
          <span>no</span>
        </label>
      </div>

      <select *ngIf="q.questionTypeId === QuestionType.Select"
              class="select-control"
              [(ngModel)]="q.currentValue"
              (change)="onAnswerChanged(q)">
        <option value="">Select…</option>
        <option *ngFor="let o of q.options" [value]="o.id.toString()">
          {{ o.label | lowercase }}
        </option>
      </select>

      <select *ngIf="q.questionTypeId === QuestionType.YesNoQ"
              class="select-control"
              [(ngModel)]="q.currentValue"
              (change)="onAnswerChanged(q)">
        <option value="">Select…</option>
        <option *ngFor="let o of yesNoQOptions" [value]="o.value">
          {{ o.label | lowercase }}
        </option>
      </select>

      <select *ngIf="q.questionTypeId === QuestionType.Goodwill"
              class="select-control"
              [(ngModel)]="q.currentValue"
              (change)="onAnswerChanged(q)">
        <option value="">Select…</option>
        <option *ngFor="let o of goodwillOptions" [value]="o.value">
          {{ o.label | lowercase }}
        </option>
      </select>

      <div *ngIf="q.questionTypeId === QuestionType.MultipleChoice"
           class="option-group radio">
        <label class="option" *ngFor="let o of q.options">
          <input type="radio"
                 [name]="'q' + q.id"
                 [value]="o.id.toString()"
                 [(ngModel)]="q.currentValue"
                 (change)="onAnswerChanged(q)">
          <span>{{ o.label | lowercase }}</span>
        </label>
      </div>

      <div *ngIf="q.questionTypeId === QuestionType.MultiSelect"
           class="option-group checkbox">
        <label class="option" *ngFor="let o of q.options">
          <input type="checkbox"
                 [checked]="isChecked(q, o.id)"
                 (change)="toggleMulti(q, o.id)">
          <span>{{ o.label | lowercase }}</span>
        </label>
      </div>

      <input *ngIf="q.questionTypeId === QuestionType.Text"
             type="text"
             [(ngModel)]="q.currentValue"
             (input)="onTextChanged(q)"
             (blur)="onTextBlur(q)">
    </div>
    </ng-container>
  </div>
</div>
